import { render, staticRenderFns } from "./integralPlay.vue?vue&type=template&id=413ad2d3&scoped=true"
import script from "./integralPlay.vue?vue&type=script&lang=js"
export * from "./integralPlay.vue?vue&type=script&lang=js"
import style0 from "./integralPlay.vue?vue&type=style&index=0&id=413ad2d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413ad2d3",
  null
  
)

export default component.exports